<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
    <path
      d="M6 0C2.69 0 0 2.69 0 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6Zm2.324 7.377a.663.663 0 0 1-.467 1.136.649.649 0 0 1-.468-.189L6 6.947 4.624 8.324a.67.67 0 0 1-.934 0 .663.663 0 0 1 0-.947L5.053 6 3.676 4.623a.663.663 0 0 1 0-.947.663.663 0 0 1 .947 0L6 5.053l1.377-1.377a.663.663 0 0 1 .947 0 .663.663 0 0 1 0 .947L6.947 6l1.377 1.377Z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </svg>
</template>
